module.exports = __webpack_public_path__ + "static/img/xk.d4d7255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/xk.jpg
// module id = mCmL
// module chunks = 1